import { PublicClientApplication } from '@azure/msal-browser'
import { saveToIndexedDB } from '../utils/idbUtils'
import { configuration, commonLoginAuthority } from '../config/OnboardingConfig'

let msalInstance

export const getMsal = () => {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(configuration)
  }
  return msalInstance
}

export const initMsal = async () => {
  const pca = getMsal()
  await pca.initialize()
  return pca
}

export const acquireToken = async (scopes, authority = commonLoginAuthority) => {
  const pca = getMsal()
  const activeAccount = pca.getActiveAccount() || (pca.getAllAccounts && pca.getAllAccounts()[0])
  try {
    const silent = await pca.acquireTokenSilent({ scopes, authority, account: activeAccount })
    if (silent) {
      // Ensure active account is set for subsequent silent calls
      if (silent.account) pca.setActiveAccount(silent.account)
      try {
        await saveToIndexedDB('userProfile', {
          displayName: silent.account?.name || '',
          userPrincipalName: silent.account?.username || '',
          oid: silent.account?.idTokenClaims?.oid || '',
        })
      } catch (_) {}
      return silent.accessToken
    }
  } catch (_) {}

  // If no active account, popup may require account selection; otherwise avoid forcing select_account
  const popupRequest = activeAccount
    ? { scopes, authority }
    : { scopes, authority, prompt: 'select_account' }

  const interactive = await pca.acquireTokenPopup(popupRequest)
  if (interactive?.account) pca.setActiveAccount(interactive.account)
  try {
    await saveToIndexedDB('userProfile', {
      displayName: interactive.account?.name || '',
      userPrincipalName: interactive.account?.username || '',
      oid: interactive.account?.idTokenClaims?.oid || '',
    })
  } catch (_) {}
  return interactive.accessToken
}

export const minimalGraphScopes = [
  'https://graph.microsoft.com/DelegatedAdminRelationship.Read.All',
  'https://graph.microsoft.com/RoleManagement.Read.Directory',
]

export const acquireMinimalGraphToken = async () => {
  return await acquireToken(minimalGraphScopes)
}


